module.exports = __webpack_public_path__ + "img/cad5.e970fc9b.png";